<div id="pageablePickListModal" class="modal is-touch is-short" [ngClass]="{ 'is-open': isOpen}" (transitionend)="setFocus($event)">
  @if (isOpen) {
    <div class="modal__content">
      <div class="modal__header">
        <div class="h3">{{title}}</div>
      </div>
      <div class="modal__bodypby0 height100 relative">
        @if (getPaginationAndSearch()) {
          <div id="pageableListSearch" class="row no-gutters px2 pb2">
            <div class="col-12 form-group">
              <label>Search</label>
              <div class="form-group__icon-container">
                <input id="pickListFilter" type="text" class="form-control" value="" placeholder="Search {{title}}" [(ngModel)]="itemDescription"
                  #searchFieldInput (keyup)="onSearchFilterChanged()">
                @if (itemDescription) {
                  <div id="clearSearchInput" nc-clear-search-input [searchTextField]="searchTextFieldInput" (clearSearch)="clearSearch()"></div>
                } @else {
                  <svg id="searchIcon">
                    <use xlink:href="./assets/icons/connect-icons.svg#Search"></use>
                  </svg>
                }
              </div>
            </div>
          </div>
        }
        @if (isOpen) {
          <div class="touch-table__table-wrapper height100">
            <div class="row no-gutters pl2 width100">
              <div [ngClass]="{'col-11':getPaginationAndSearch(), 'col-12': !getPaginationAndSearch()}" class="pageable-pick-list-button-area-height">
                <div id="pageablePickListModalItems" class="row no-gutters">
                  @for (item of filterPickListItems() | paginate: pagingConfig; track trackItem(i, item); let i = $index) {
                    <div class="col-3 pr2 mb2">
                      <div id="{{getId(item.text)}}" (click)="onItemClicked(item)" class="form-control__multi-select is-tall"
                        [ngClass]="{ 'is-selected': isSelected(item), 'is-disabled': setDisable(item) }">
                        <div>
                          @if (setDisable(item)) {
                            <svg class="h5">
                              <use xlink:href="./assets/icons/connect-icons.svg#Warning"></use>
                            </svg>
                          }
                          {{item.text}}
                        </div>
                      </div>
                    </div>
                  }
                  @if (filterPickListItems()?.length === 0) {
                    <div id="noResults" class="has-no-results mt5">
                      0 Results Found
                    </div>
                  }
                </div>
                @if (showWitnessAlert()) {
                  <div class="flex align-center h5 mb2 bg-navy-94 p2 mr2" id="witnessAlert">
                    <svg class="fill-warning-dark width-3 height-3 mr1">
                      <use xlink:href="./assets/icons/connect-icons.svg#Warning"></use>
                    </svg>
                    <div>
                      <div class="h3 gray-40">Witness Required setting is <span class="bold">ON</span></div>
                      <div id="witnessAlertMsg" class="h5 gray-40">The Dispense Type cannot be set to Under Hood because Witness Required setting is
                        turned
                        On. Click <span class="bold">View Stations</span> for more details.</div>
                    </div>
                    <div class="btn btn--core-blue bg-blue-73 border-blue-73 whitespace-nowrap ml2" id="showStationsModal"
                      (click)="showStationListModal()">
                      {{getStationButtonText()}}
                    </div>
                  </div>
                }
                @if (showWarningAlert()) {
                  <div class="flex align-center h5 mb2 bg-navy-94 p2 mr2" id="warningAlert">
                    <svg class="fill-danger-core width-3 height-3 mr1">
                      <use xlink:href="./assets/icons/connect-icons.svg#Warning"></use>
                    </svg>
                    <div>
                      <div id="warningAlertTitle" class="h3 gray-40">{{warningTitle}}</div>
                      <div id="warningAlertMsg" class="h5 gray-40" [innerHTML]="warningMessage"></div>
                      <div class="h3 gray-40"></div>
                    </div>
                  </div>
                }
              </div>
              @if (getPaginationAndSearch()) {
                <ul id="paginationControls" class="touch-pagination mtn2">
                  <div nc-pagination-controls [config]="pagingConfig"></div>
                </ul>
              }
            </div>
          </div>
        }
      </div>
      <div class="modal__footer justify-content-between">
        <button id="btnCancelPickListModal" (click)="onCancelPickListModal()" class="btn btn--true-blue-inverse">Cancel</button>
        <button id="clearLotButton" (click)="onClearPickListModal()" class="btn btn--core-blue">Clear
          Selection</button>
      </div>
    </div>
  }
</div>

<div id="stationListModalDispenseType" nc-station-list-underhood [type]="stationListSetting" [isUnderHoodModalOpen]="isUnderHoodModalOpen|async"
  [selectedItems]="stations|async"></div>
